export const getOpenRtuIdFromPath = (pathname: string): string | null => {
  const match = pathname.match(/^\/rtupage\/([^/?#]+)/);
  return match ? decodeURIComponent(match[1]) : null;
};

export const getPartialUpdateRtuId = (payload: unknown): string | null => {
  if (!payload || typeof payload !== 'object') {
    return null;
  }

  const candidate = (payload as { id?: unknown; rtuId?: unknown }).id ?? (payload as { rtuId?: unknown }).rtuId;
  if (candidate === undefined || candidate === null || candidate === '') {
    return null;
  }

  return String(candidate);
};

export const shouldRefreshOpenRtuDetail = (pathname: string, payload: unknown): string | null => {
  const openRtuId = getOpenRtuIdFromPath(pathname);
  const updateRtuId = getPartialUpdateRtuId(payload);

  if (!openRtuId || !updateRtuId) {
    return null;
  }

  return openRtuId === updateRtuId ? openRtuId : null;
};
